import { LiveModel } from '@descomplica/dex-models';

export const EVENT_SOURCE_TYPE = {
  zoom: 'Zoom',
  kaltura: 'Kaltura',
};

export const LIVE_TYPE = {
  live: 'live',
  vod: 'rerun',
};

export const getEventLiveType = (event?: LiveModel) =>
  event?.sourceType === 'Zoom' ? LIVE_TYPE.live : LIVE_TYPE.vod;
